// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__27jZu","footer":"ReportModalFilter_footer__1K0Mh"};